<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Attachments|File Attachments in WebView') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'Attachments|File upload and download functionality may not work reliably in Telegram WebView due to client limitations and security restrictions.'
                )
              }}
            </p>

            <h4>{{ s__('Attachments|Why It May Not Work') }}</h4>
            <ul style="margin: 0 0 16px 0; padding-left: 20px; color: #666">
              <li style="margin-bottom: 8px">
                {{ s__('Attachments|WebView has limited file system access') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('Attachments|Download functionality depends on WebView implementation') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('Attachments|Some file types may not be supported') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('Attachments|Security restrictions may block file operations') }}
              </li>
            </ul>

            <h4>{{ s__('Attachments|Recommended Solution') }}</h4>
            <p>
              {{
                s__(
                  'Attachments|For the best experience with file attachments, we recommend using the application in a regular web browser.'
                )
              }}
            </p>

            <h4>{{ s__('Attachments|How to Access via Browser') }}</h4>
            <ol style="margin: 0 0 16px 0; padding-left: 20px; color: #666">
              <li style="margin-bottom: 8px">
                {{ s__('Attachments|Open the bot in Telegram') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('Attachments|Send the command:') }}
                <code
                  style="
                    background: #f3f4f6;
                    padding: 2px 6px;
                    border-radius: 4px;
                    font-family: monospace;
                    color: #2aabee;
                  "
                  >/browser_auth</code
                >
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('Attachments|Click on the link provided by the bot') }}
              </li>
              <li style="margin-bottom: 8px">
                {{
                  s__(
                    'Attachments|The application will open in your default browser with full file support'
                  )
                }}
              </li>
            </ol>

            <div
              style="
                background: #f0f9ff;
                border: 1px solid #0ea5e9;
                border-radius: 8px;
                padding: 12px;
                margin-top: 16px;
              "
            >
              <p style="margin: 0; color: #0c4a6e; font-size: 14px">
                <strong>{{ s__('Attachments|Note:') }}</strong>
                {{
                  s__(
                    'Attachments|The browser version provides full functionality including reliable file uploads and downloads.'
                  )
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Attachments|Got it') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from './icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}

.info-section ul,
.info-section ol {
  line-height: 1.6;
}

.info-section code {
  background: #f3f4f6;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
  color: #2aabee;
  font-size: 14px;
}
</style>
